import React from 'react'

function Privacy() {
    return (
        <div>
            <div class="breadcrumb_section bg_gray page-title-mini">
                <div class="container">
                    <div class="row align-items-center">

                        <div class="page-title">
                            <h1> PRIVACY POLICY</h1>
                        </div>

                        <div class="col-md-6">

                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-6">
                            <div class="heading_s1 mb-3 mb-md-5">
                                <h3>Content</h3>
                            </div>
                            <div id="accordion" class="accordion accordion_style1">
                                <div class="card">
                                    <div class="card-header" id="headingOne">
                                        <h6 class="mb-0"> <a class="collapsed" data-bs-toggle="collapse" href="#collapseOne"
                                            aria-expanded="true" aria-controls="collapseOne">Security and
                                            Confidentiality</a>
                                        </h6>
                                    </div>
                                    {/* <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                                        data-bs-parent="#accordion"> */}
                                        <div class="card-body">
                                            <ol>-We strive every day to develop appropriate security measures to protect
                                                your Personal Data from unauthorized access or loss due to cyber theft."
                                            </ol>
                                            <li>-Our employees recognize the importance of maintaining the confidentiality
                                                of Personal Data collected.</li>
                                            <li>-We recommend that you take every precaution to protect your personal data
                                                when accessing the Internet. Although we strive to protect your personal
                                                data, we cannot guarantee the absolute security of information you transmit
                                                over the Internet.</li>
                                            <li>-Where we have given you (or where you have chosen) a password which enables
                                                you to access certain parts of the Website, you are responsible for keeping
                                                this password confidential. You are not allowed to share your password with
                                                anyone.</li>
                                        </div>
                                    {/* </div> */}
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingTwo">
                                     <h6 class="mb-0"> <a class="collapsed" data-bs-toggle="collapse" href="#collapseTwo"
                                            aria-expanded="false" aria-controls="collapseTwo"><span>Access, rectification,
                                            withdrawal of consent and other rights</span>
                                        </a> </h6>
                                    </div>
                                    {/* <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                        data-bs-parent="#accordion"> */}
                                        <div class="card-body">
                                            <p>To the extent permitted by applicable data protection and privacy laws, you
                                                may access, review, correct and update your Personal Data, and withdraw your
                                                consent to with the use of Personal Data.</p>
                                            <p>If you wish to access, review, correct, update or withdraw your consent to
                                                the use of Personal Data you have submitted through the Website or have any
                                                request regarding the processing of such information, Please contact us for
                                                information.</p>
                                        </div>
                                    {/* </div> */}
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingThree">
                                        <h6 class="mb-0"> <a class="collapsed" data-bs-toggle="collapse"
                                            href="#collapseThree" aria-expanded="false"
                                            aria-controls="collapseThree">Disclosure and Retention</a> </h6>
                                    </div>
                                    {/* <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                        data-bs-parent="#accordion"> */}
                                        <div class="card-body">
                                            <p>We may provide or transfer Personal Data you provide to other Harver Electric
                                                entities, authorized dealers and suppliers contracted with us to provide the
                                                service you request. request for the purposes described in Your personal
                                                data may also be disclosed to digital. advertising platforms (Facebook,
                                                Google and other media) if you use features provided by digital advertising
                                                media. digital integration into our website. </p>
                                            <p>Your Personal Data will be disclosed to third parties without your consent in
                                                the following cases:</p>
                                            <ul class="list_style_3">
                                                <li> Required by state law, summons or court order;</li>
                                                <li>at the request of a government, state regulatory agency or law
                                                    enforcement agency;</li>
                                                <li>to investigate and prevent security threats, fraud or other harmful
                                                    activity;</li>
                                                <li>to enforce/protect the rights and property of Harver Electric or its
                                                    affiliates; or to protect the rights or personal safety of Harver
                                                    Electric employees and third parties.</li>
                                            </ul>
                                        </div>
                                    {/* </div> */}
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingFour">
                                        <h6 class="mb-0"> <a class="collapsed" data-bs-toggle="collapse"
                                            href="#collapseFour" aria-expanded="false"
                                            aria-controls="collapseFour">Overview</a> </h6>
                                    </div>
                                    {/* <div id="collapseFour" class="collapse" aria-labelledby="headingFour"
                                        data-bs-parent="#accordion"> */}
                                        <div class="card-body">
                                            <p>This Privacy Policy provides a general statement about how we aim to protect
                                                and use your Personal Data. However, you may be provided with privacy
                                                policies or statements that supplement this Privacy Policy for any
                                                particular product or service offered by us or a member of our group.
                                                provided by Harver Electric group.</p>
                                        </div>
                                    {/* </div> */}
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingFive">
                                        <h6 class="mb-0"> <a class="collapsed" data-bs-toggle="collapse"
                                            href="#collapseFive" aria-expanded="false"
                                            aria-controls="collapseFive">Contact Info</a> </h6>
                                    </div>
                                    {/* <div id="collapseFive" class="collapse" aria-labelledby="headingFive"
                                        data-bs-parent="#accordion"> */}
                                        <div class="card-body">
                                            <p>If you need assistance accessing or updating the Personal Data we have
                                                collected, or if you have any questions regarding this Privacy Policy,
                                                please contact our Guest Services Officer our products at
                                                dpo@vn.harverelectric.com.</p>
                                        </div>
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 mt-4 mt-md-0">
                            <div class="heading_s1 mb-3 mb-md-5">
                                <h3>Other questions</h3>
                            </div>
                            <div id="accordion2" class="accordion accordion_style1">
                                <div class="card">
                                    <div class="card-header" id="headingSix">
                                        <h6 class="mb-0"> <a class="collapsed" data-bs-toggle="collapse" href="#collapseSix"
                                            aria-expanded="true" aria-controls="collapseSix"></a>What is the purpose of
                                            collecting information and the scope of information use? </h6>
                                    </div>
                                    {/* <div id="collapseSix" class="collapse show" aria-labelledby="headingSix"
                                        data-bs-parent="#accordion2"> */}
                                        <div class="card-body">
                                            <p>The information you provide via email to us, or information you send directly
                                                to our contact address will help us:</p>
                                            <li>- Support customers when purchasing Harver Electric products.</li>
                                            <li>- Answer customer questions.</li>
                                            <li>- Provide you with information about the latest software versions & updates
                                                on our website.</li>
                                            <li>- Review and upgrade the content and interface of the website.</li>
                                            <li>- Carry out customer surveys.</li>
                                            <li>- Carry out promotional activities related to Harver Electric products and
                                                services.</li>

                                        </div>
                                    {/* </div> */}
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingSeven">
                                        <h6 class="mb-0"> <a class="collapsed" data-bs-toggle="collapse"
                                            href="#collapseSeven" aria-expanded="false"
                                            aria-controls="collapseSeven">Information storage time?</a>
                                        </h6>
                                    </div>
                                    {/* <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven"
                                        data-bs-parent="#accordion2"> */}
                                        <div class="card-body">
                                            <p>The customer's personal data will be stored until cancellation is requested.
                                                In all other cases, customer personal information will be kept confidential
                                                on Toshiba's internal system</p>

                                        </div>
                                    {/* </div> */}
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingEight">
                                        <h6 class="mb-0"> <a class="collapsed" data-bs-toggle="collapse"
                                            href="#collapseEight" aria-expanded="false"
                                            aria-controls="collapseEight">Support time to answer customer questions?</a>
                                        </h6>
                                    </div>
                                    <div id="collapseEight" class="collapse" aria-labelledby="headingEight"
                                        data-bs-parent="#accordion2">
                                        <div class="card-body">
                                            <p>Harvel Electric is ready to serve 24/7 </p>

                                            <ul class="list_style_3">

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingNine">
                                        <h6 class="mb-0"> <a class="collapsed" data-bs-toggle="collapse"
                                            href="#collapseNine" aria-expanded="false" aria-controls="collapseNine">What
                                            is an overview of the privacy policy?</a> </h6>
                                    </div>
                                    {/* <div id="collapseNine" class="collapse" aria-labelledby="headingNine"
                                        data-bs-parent="#accordion2"> */}
                                        <div class="card-body">
                                            <p>In this Privacy Policy, we describe the types of personal information we will
                                                collect through our Services, how we use this information, how long we
                                                retain it and with whom we share that information. We also explain your
                                                choices and rights regarding the use of your information, including the
                                                right to object to certain processing we carry out (where provided for in
                                                applicable law). More information about your rights, and how to exercise
                                                them, is set out in the “Your Rights” section. We also provide our contact
                                                details so you can contact us if you have questions about this Privacy
                                                Policy and our privacy practices.</p>

                                            <ul class="list_style1">
                                            </ul>
                                        </div>
                                    {/* </div> */}
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingTen">
                                        <h6 class="mb-0"> <a class="collapsed" data-bs-toggle="collapse" href="#collapseTen"
                                            aria-expanded="false" aria-controls="collapseTen">How do we keep your
                                            personal data safe?</a>
                                        </h6>
                                    </div>
                                    {/* <div id="collapseTen" class="collapse" aria-labelledby="headingTen"
                                        data-bs-parent="#accordion2"> */}
                                        <div class="card-body">
                                            <p>We take the protection of personal data seriously. We have established
                                                physical and technical safeguards to ensure the security of the personal
                                                data we collect. We also take appropriate measures, in compliance with
                                                Applicable Laws, to ensure that personal data collected by third parties
                                                remains secure. However, please note that although we have taken reasonable
                                                measures to protect your personal data, no website, Internet transmission,
                                                computer system or wireless connection is completely safe.
                                            </p>
                                        </div>
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Privacy
